import currencyFormatter from 'currency-formatter';

const currencies = {HUF: 0, FT: 0, EUR: 2, '€': 2, USD: 2, '$': 2, GBP: 2, '£': 2};

// Format only monetary values; counts, percentages and text retain their precision.
export function formatReportMoney(value, currency) {
  const precision = currencies[String(currency || '').trim().toUpperCase()];
  if (precision === undefined || value == null || value === '' || typeof value === 'boolean') return value;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return value;
  const locale = localStorage.getItem('user.locale') || localStorage.getItem('userLocale') || 'hu';
  return currencyFormatter.format(numeric, {
    precision, symbol: '', decimal: locale.toLowerCase().startsWith('en') ? '.' : ',',
    thousand: locale.toLowerCase().startsWith('en') ? ',' : ' ',
  });
}
